// Returns true if the object is empty
export function isEmptyObject(anything: any) {
  if (typeof anything !== "object") {
    return false;
  }
  const keys = Object.keys(anything);
  return keys.length === 0;
}
